import { axios } from '@Root/API'

export const get = payload => {
	return axios.get(`engagement/${payload}/student-registration`)
}
